<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="Page_vii">June of 1998<br/>Port Orchard</a></p><a id="Page_vii">
<p class="noindent1">Dear Friends,</p>
<p class="indent">Welcome to the Springwater stagecoach station, which will grow before your very eyes, into a thriving community, complete with a saloon, a schoolhouse, a church, and a newspaper, among other things. There are six books in the Springwater series, although I may do more. I love the idea of writing a long, involved story and watching this fictional town full of delightful people come to life. I hope the many and varied characters will become as dear to you as they are to me.</p>
<p class="indent">Let me know what you think, and to receive a copy of the <em>Springwater Gazette,</em> Springwater’s own newspaper, please send a business-sized stamped, self-addressed envelope, with your address clearly printed. We’ll add you to the newsletter list automatically, thus giving you advance notice of every new release, whether it is part of this series or not. The address is:</p>
</a><p class="center"><a id="Page_vii">Linda Lael Miller<br/> P.O. Box 669<br/> Port Orchard, WA 98366<br/> e-mail: </a><a href="mailto:lindalaelm@aol.com">lindalaelm@aol.com</a></p>
<p class="indent">God bless and keep.</p>
<p class="noindent1">Warmly,</p>
<p class="image"><img alt="Image" src="images/img01_1-8.jpg"/></p>
<p class="noindent">Linda Lael Miller</p>
<p><a id="Page_viii"></a></p><a id="Page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?7f4a8a00